import { RecursivePartial } from '@models/base';
import { BaseTaskAction, TaskActionType } from './_base-task-action';

export class TaskActionPlannedHours extends BaseTaskAction {
    type: TaskActionType.PlannedHours = TaskActionType.PlannedHours;
    plannedUnits: number = 0;
    plannedUnitsOld: number = 0;

    constructor(json?: RecursivePartial<TaskActionPlannedHours>) {
        super(json);
        this.parseTaskActionPlannedHours(json || {});
    }

    parse(json: RecursivePartial<TaskActionPlannedHours>): TaskActionPlannedHours {
        super.parse(json);
        this.parseTaskActionPlannedHours(json);
        return this;
    }

    private parseTaskActionPlannedHours(json: RecursivePartial<TaskActionPlannedHours>): void {
        TaskActionPlannedHours.assignFields<TaskActionPlannedHours>(this, json, ['plannedUnits', 'plannedUnitsOld']);
    }
}
